import { render } from "./AddTypeDocumentModalPage.vue?vue&type=template&id=0794b465&ts=true"
import script from "./AddTypeDocumentModalPage.vue?vue&type=script&lang=ts"
export * from "./AddTypeDocumentModalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__